import { onBeforeUnmount, onMounted, ref } from 'vue'

export function useMediaQuery(query: string) {
  const matches = ref(
    import.meta.client ? window.matchMedia(query).matches : false,
  )

  let mediaQueryList: MediaQueryList | null = null

  const onChange = (event: MediaQueryListEvent) => {
    matches.value = event.matches
  }

  onMounted(() => {
    mediaQueryList = window.matchMedia(query)
    matches.value = mediaQueryList.matches
    mediaQueryList.addEventListener('change', onChange)
  })

  onBeforeUnmount(() => {
    mediaQueryList?.removeEventListener('change', onChange)
  })

  return matches
}
